import type { LoginAuthorizeData } from '@/features/auth/services/use-mutation-login-authorize';

export type PermissionsSchema = Pick<
  LoginAuthorizeData,
  'id' | 'apiPermissions'
>;

export const permissionsSchema = '&id, *apiPermissions';
